import { defineCopy } from "../intl";

import { LANGUAGE_SETTINGS_COPY_EN_US } from "./en-us/language-settings.copy";
import { LANGUAGE_SETTINGS_COPY_ES_ES } from "./es-es/language-settings.copy";

/** Seção "Idioma" da aba Perfil do "Gerenciar conta", nas três plataformas. */
export const LANGUAGE_SETTINGS_COPY_PT_BR = {
  title: "Idioma",
  description:
    "O idioma da Tãmi, dos e-mails e das notificações. Fica salvo na sua conta e vale no web, no app e no desktop.",
  groupLabel: "Idioma da Tãmi",
  /** Legenda curta sob o seletor no cabeçalho do perfil (direção C, 2026-10-01). */
  caption: "Idioma da Tãmi, e-mails e notificações",
  saveError: "Não foi possível trocar o idioma. Tente de novo.",
} as const;

export const LANGUAGE_SETTINGS_COPY = defineCopy(LANGUAGE_SETTINGS_COPY_PT_BR, {
  "en-US": LANGUAGE_SETTINGS_COPY_EN_US,
  "es-ES": LANGUAGE_SETTINGS_COPY_ES_ES,
});
